import { render, staticRenderFns } from "./job-request-briefing-form.vue?vue&type=template&id=4671c073&"
import script from "./job-request-briefing-form.vue?vue&type=script&lang=js&"
export * from "./job-request-briefing-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports